<template>
  <div>
    <order-search company-title="Sofie" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import OrderSearchVue from "@/components/sofie/OrderSearch.vue";

export default defineComponent({
  components: {
    "order-search": OrderSearchVue,
  },
});
</script>
